import { put, takeEvery } from "redux-saga/effects";
import {
  fetchGraphMethod,
  fetchMethod,
} from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  MEMBERSHIP_LIST_START: "MEMBERSHIP_LIST_START",
  MEMBERSHIP_LIST_SUCCESS: "MEMBERSHIP_LIST_SUCCESS",
  MEMBERSHIP_LIST_FAILED: "MEMBERSHIP_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const membershipListStart = (data) => ({
  type: actionType.MEMBERSHIP_LIST_START,
  payload: data,
});

export const membershipListSuccess = (data) => ({
  type: actionType.MEMBERSHIP_LIST_SUCCESS,
  payload: data,
});

export const membershipListFailed = (data) => ({
  type: actionType.MEMBERSHIP_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function membershipListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.MEMBERSHIP_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.MEMBERSHIP_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.MEMBERSHIP_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}
//
const checkMemberShip = (value) =>{
  const status = value?.length > 0 ? true : false || false,
      memberShip = [],
      totalMemberShip = value || []
  if (status) {
    totalMemberShip.map(el => !!el.subscriptionplanid && memberShip.push(el.subscriptionplanid))
  }
  if (memberShip.length > 0) return true
  else return false
}

// ===================================================== side effect =============================================

export function* membershipListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(
        membershipListSuccess({
          allMemberships: response?.data?.data?.allMemberships?.Memberships ?? [],
          isPremiumUser : checkMemberShip(response.data.data.allMemberships.Memberships)
        })
      );
    } else {
      messagePopup("", "Membership List failed", "error");
      yield put(membershipListFailed("Membership List failed"));
    }
  } catch (error) {
    messagePopup("", "Membership List failed", "error");
    yield put(membershipListFailed("Membership List failed"));
  }
}

export function* watchMembershipListSaga() {
  yield takeEvery(actionType.MEMBERSHIP_LIST_START, membershipListSaga);
}
